import { GroupedTableFlatRow } from "../GroupedTableFlatRow";
import { GroupedTableListProps } from "./GroupedTableList.types";
import { useGroupedTableInternal } from "../utils";
import localize from "src/l10n/localize";
import { MediumBodyBolder } from "src/components/Text";

function GroupedTableList<TRow>(_: GroupedTableListProps) {
    const { flatItems } = useGroupedTableInternal<TRow>();

    return (
        <div className="GroupedTableList">
            {flatItems.length === 0 && (
                <div className="GroupedTableList-empty">
                    <MediumBodyBolder color="contentNormal">
                        {localize("ORG_PAGE_NO_CONTENT")}
                    </MediumBodyBolder>
                </div>
            )}
            {flatItems.map((row, index) => (
                <GroupedTableFlatRow<TRow>
                    key={row.key + "|" + index}
                    item={row} />
            ))}
        </div>
    );
}

export default GroupedTableList;
